import React, { useLayoutEffect, useRef } from 'react';
import { useRemoveWebchatKeyboardFocusTraps } from '../hooks';
const adaptiveCardARIARoleMessageMiddleware = () => (next) => (...args) => {
    const { activity: { attachments } } = args[0];
    const render = next(...args);
    if (typeof render !== 'function')
        return render;
    if (attachments === null || attachments === void 0 ? void 0 : attachments.some((a) => a.contentType == 'application/vnd.microsoft.card.adaptive')) {
        return (...children) => {
            useRemoveWebchatKeyboardFocusTraps();
            const wrapperEl = useRef(null);
            useLayoutEffect(() => {
                var _a, _b, _c, _d;
                (_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[aria-roledescription=attachment]').forEach((attachment) => {
                    attachment.setAttribute('aria-roledescription', 'message');
                });
                document
                    .querySelectorAll('[aria-hidden=true][id^=webchat__basic-transcript__active-descendant-label]')
                    .forEach((attachment) => {
                    attachment.removeAttribute('aria-hidden');
                });
                (_b = wrapperEl.current) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[role=menubar] [role=menuitem]').forEach((attachment) => {
                    attachment.setAttribute('role', 'listitem');
                });
                (_c = wrapperEl.current) === null || _c === void 0 ? void 0 : _c.querySelectorAll('[role=menubar] [role=button]').forEach((attachment) => {
                    attachment.setAttribute('role', 'listitem');
                });
                (_d = wrapperEl.current) === null || _d === void 0 ? void 0 : _d.querySelectorAll('[role=menubar]').forEach((attachment) => {
                    attachment.setAttribute('role', 'list');
                });
            }, []);
            return React.createElement("div", { ref: wrapperEl }, render(...children));
        };
    }
    else {
        return (...children) => {
            useRemoveWebchatKeyboardFocusTraps();
            return React.createElement(React.Fragment, null, render(...children));
        };
    }
};
export { adaptiveCardARIARoleMessageMiddleware };
//# sourceMappingURL=adaptiveCardARIARoleMessageMiddleware.js.map